import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import get from 'lodash/get';
import { mapState } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreDetailsPageField',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    originalItem: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false
    },
    updateItemByFieldKey: {
      type: Function,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showRenderedMarkdown: false,
      confirmationDialogs: [],
      noInputRendering: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    itemValue: function itemValue() {
      return get(this.item, this.field.key);
    },
    itemValueDidChange: function itemValueDidChange() {
      var originalItemValue = get(this.originalItem, this.field.key);

      if (this.itemValue === '' && (originalItemValue === null || originalItemValue === undefined)) {
        return false;
      }

      return this.itemValue !== originalItemValue;
    },
    cypressTagValue: function cypressTagValue() {
      if (this.field.cyTag) {
        return this.field.cyTag;
      }

      return "details-page-field-".concat(this.field.key);
    },
    fieldLabel: function fieldLabel() {
      return "".concat(this.field.label).concat(this.itemValueDidChange ? " (".concat(this.$i18n_t('Core.DetailsPage.fields.common.didChangePostfix'), ")") : '').concat(this.field.required ? ' *' : '');
    },
    fieldValue: function fieldValue() {
      return 'value' in this.field ? this.field.value : this.itemValue;
    },
    showField: function showField() {
      return typeof this.field.if === 'function' ? this.field.if(this.item) : true;
    },
    fieldIsDisabled: function fieldIsDisabled() {
      return !this.editMode || this.field.readonly || this.isProductiveVersion;
    }
  }),
  methods: {
    waitForUserConsent: function () {
      var _waitForUserConsent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(title, message) {
        var dialog, dialogPromise, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dialog = {
                  identifier: "".concat(Date.now(), "-").concat(title, "-").concat(Math.random()),
                  title: title,
                  message: message,
                  show: true,
                  resolve: null
                };
                dialogPromise = new Promise(function (resolve) {
                  dialog.resolve = resolve;
                });
                this.confirmationDialogs.push(dialog);
                _context.next = 5;
                return dialogPromise;

              case 5:
                result = _context.sent;
                dialog.show = false;
                this.confirmationDialogs = this.confirmationDialogs.filter(function (dialog) {
                  return dialog.identifier !== dialogPromise.identifier;
                });
                return _context.abrupt("return", result);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function waitForUserConsent(_x, _x2) {
        return _waitForUserConsent.apply(this, arguments);
      }

      return waitForUserConsent;
    }(),
    onInputChange: function onInputChange(value) {
      var _this = this;

      if (typeof this.field.onInput === 'function') {
        this.field.onInput({
          value: value,
          item: this.item,
          updateItemByFieldKey: this.updateItemByFieldKey,
          waitForUserConsent: this.waitForUserConsent,
          rerenderInput: function rerenderInput() {
            _this.noInputRendering = true;

            _this.$nextTick(function () {
              _this.noInputRendering = false;
            });
          }
        });
        return;
      }

      this.$emit('input', value);
    },
    combineRules: function combineRules(field) {
      var _this2 = this;

      var internalRules = [];

      if (field.required) {
        internalRules.push(function (v) {
          return !!v || _this2.$i18n_t('Core.DetailsPage.fields.common.requiredField');
        });
      }

      return [].concat(internalRules, _toConsumableArray(get(field, 'rules', [])));
    }
  }
};